module.exports = __webpack_public_path__ + "static/img/logo5.7cf4624.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/images/partner/logo5.png
// module id = B+Iv
// module chunks = 1